import { format, parse } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import moment from 'moment-timezone';

/**
  Return the formatted date string in the given format.
  https://date-fns.org/v2.25.0/docs/format
*/
type NamedArgs = { parseFormat?: string; timezone?: string; parseOptions?: object };
export default function dateFormat(
  date: Date | string | moment.Moment,
  formatString: string,
  { parseFormat, timezone, parseOptions }: NamedArgs = {},
): string {
  let _date: Date;
  parseOptions = parseOptions ?? {};

  // TODO: remove this if we don't use moment anymore
  if (moment.isMoment(date)) {
    _date = date.toDate();
  } else if (typeof date === 'string') {
    _date = typeof parseFormat === 'string' ? parse(date, parseFormat, new Date(), parseOptions) : new Date(date);
  } else {
    _date = date ?? new Date();
  }

  // Beware: invalid date strings will not parse to a valid date; date-fns will throw an error when trying to format one
  if (isNaN(_date.getTime())) return '';

  return timezone
    ? formatInTimeZone(_date, timezone, formatString, parseOptions)
    : format(_date, formatString, parseOptions);
}
